// import { action, observable } from "mobx";
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import { makePaginated } from '../../../../adl-gen/common';
import { DbKey, WithDbId } from '../../../../adl-gen/common/db';
import { Skill } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { LangCode, withI18n, WithI18nProps } from '../../../../internationalization/i18n-hoc';
import { EditIcon } from '../../../../ui/common/icons';
import { Modal } from '../../../../ui/components/modal/modal';
import { Tile } from '../../../../ui/components/tile/tile';
import { Button } from '../../../../ui/widgets/button/button';
import { MarkdownContent } from '../../../../ui/widgets/markdown-content/markdown-content';
import { Pill } from '../../../../ui/widgets/pill/pill';
import { Select, SelectOption } from '../../../../ui/widgets/select/select';
import { DisplayI18nText, DisplayText } from '../../common/editor';
import { SkillListAndData } from 'src/admin/stores';
import { ListView } from '../../common/list/list-view';
import { AssignedTrainingOfferingListView } from '../lists/skill-lists/skill-to-training-offering-list-view';

const styles = require('../../common/details-view.css');
const commonStyles = require('../../common/common.css');
const editorStyles = require('../../common/editor.css');

interface SkillDetailsViewProps extends WithI18nProps {
  skill: WithDbId<Skill>;
  data: SkillListAndData;
  onUpdate(skillId: DbKey<Skill>): Promise<void>;
  role: 'super';
}

/// Make observer for the LangSelector/WithI18n HOC
@observer
class SkillDetailsView0 extends React.Component<SkillDetailsViewProps> {
  /// Language management
  @observable lang: LangCode = this.props.currentLangCode();

  @observable isOpen: boolean = false;

  @action
  changeLang = (opt: SelectOption) => {
    this.lang = opt.value as LangCode;
  };

  @action toggleOpen = () => {
    this.isOpen = !this.isOpen;
  };

  LangSelector = observer(() => {
    const { i18nOptions } = this.props;
    const onChange = this.changeLang;
    const options = i18nOptions();
    return (
      <Select
        options={options}
        defaultValue={options.find(option => (option.value as LangCode) === this.lang)}
        onChange={onChange}
      />
    );
  });

  Name = DisplayI18nText({
    field: this.props.skill.value.name,
    lang: this.lang,
    title: 'Name',
    xsSpan: 4
  });
  Definition = DisplayI18nText({
    field: this.props.skill.value.definition,
    lang: this.lang,
    title: 'Definition',
    xsSpan: 4
  });
  Ordering = DisplayText({
    field: this.props.skill.value.ordering,
    title: 'Ordering',
    xsSpan: 2
  });

  /// TODO Replace all these divs with a flexbox and flex items
  renderTopButtons = () => {
    const updateButton = () => {
      return (
        <div className={commonStyles.buttonList}>
          <Button
            onClick={async () => this.props.onUpdate(this.props.skill.id)}
            Icon={EditIcon}
            size="small"
            variant="round"
          >
            Update
          </Button>
        </div>
      );
    };

    return (
      <div className={commonStyles.buttonListContainer}>
        {updateButton()}
      </div>
    );
  };

  SkillTrainingOfferingList = () => {
    const { availableTrainingOfferings } = this.props.data.data;
    const assignedTrainingOfferings = availableTrainingOfferings
        .filter(sto => sto.value.skillId === this.props.skill.id);
    return (assignedTrainingOfferings.length > 0 ? <ListView
      list={makePaginated({
        items: assignedTrainingOfferings.map(to => ({ id: to.id, ...to.value })),
        current_offset: 0,
        total_size: assignedTrainingOfferings.length
      })}
      fields={AssignedTrainingOfferingListView}
      refData={this.props.data.data}
    /> : null);
}

  Detail = observer(() => {
    const { t, data, skill } = this.props;
    const { competencies } = data.data;
    const competency = competencies.find(c => c.id === skill.value.competencyId);
    const competencyName = competency ? t(competency.value.name).toUpperCase() : 'not found';
    return (
      <Modal
        kind="editor"
        isOpen={this.isOpen}
        onRequestClose={this.toggleOpen}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
      >
        <div className={editorStyles.title}>{t(skill.value.name)}</div>
        <div className={editorStyles.competency}>
          <Pill kind={'bordered'}>{competencyName}</Pill>
        </div>
        <div className={editorStyles.definition}>
          {/* No Internationalization */}
          <b>{'Definition'}</b>
          <p>{t(skill.value.definition)}</p>
        </div>
        <div className={editorStyles.tips}>
          <MarkdownContent text={t(skill.value.guidanceTips)} />
        </div>
      </Modal>
    );
  });

  Preview = observer(() => {
    /// Convert current input to I18nContent and use system language selector
    /// to display text
    const { data, skill, t } = this.props;
    const { competencies } = data.data;
    const competency = competencies.find(c => c.id === skill.value.competencyId);
    const competencyName = competency ? t(competency.value.name).toUpperCase() : 'not found';
    return (
      <React.Fragment>
        <this.Detail />
        <Tile
          kind={'guidance'}
          onClick={this.toggleOpen}
          detail={t(skill.value.definition)}
          title={t(skill.value.name)}
          subtitle={competencyName}
          enabled={true}
        />
      </React.Fragment>
    );
  });

  render() {
    return (
      <React.Fragment>
        <div className={styles.page}>
          <div className={styles.body}>
            <div>{this.renderTopButtons()}</div>
            <div className={styles.row}>
          <div className={styles.detailWithList}>
            <this.Preview />
            <this.SkillTrainingOfferingList />
          </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export const SkillDetailsView = withI18n(SkillDetailsView0);



// WEBPACK FOOTER //
// ./src/admin/ui/components/detail-views/skill-details-view.tsx